module.exports = "<% var curr = me.model.get(me.name) %>\n<input class=\"form-control cooper-main-input\" name=\"<%=me.name%>\" value=\"<%=curr%>\"/>\n"